/** Policies that may open payment log detail (revenue + default logs). */
export const PAYMENT_LOG_DETAIL_POLICIES = [
  'reports_revenue_payment_logs',
  'reports_default_payment_logs',
] as const
